import * as moment from "moment";

import { TaskModel } from "../../task/taskActions/models";

export const isClinicalNotesBeingCompletedInAdvance = (task: TaskModel): boolean => {
    if (!task || !task?.dueDate) {
        return false;
    }

    const currentDateTime = moment();

    if (task.dueDate.isBefore(currentDateTime)) {
        return false;
    }

    const hourLimit = 3;
    const deductedDueDate = moment(task.dueDate).subtract({ hour: hourLimit });
    return !currentDateTime.isBetween(deductedDueDate, task.dueDate);
};
